(function () {
  var DRAG_THRESHOLD = 6;
  var STORAGE_KEY = 'milk-cart-position-v3';
  var lastBannerHeight = -1;
  var cartReady = false;

  function getAnnouncementHeight() {
    var banner = document.querySelector('[data-announcement-banner]');
    if (banner && banner.offsetHeight > 0) return banner.offsetHeight;

    return (
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--announcement-banner-height')
      ) || 0
    );
  }

  function getTopBarOffset() {
    var base = window.matchMedia('(min-width: 750px)').matches ? 16 : 12;
    return base + getAnnouncementHeight();
  }

  function getCart() {
    return (
      document.querySelector('.milk-cart-global--collection') ||
      document.querySelector('.milk-cart-global--landing') ||
      document.querySelector('.milk-cart-global--fallback') ||
      document.querySelector('.milk-cart-global')
    );
  }

  function getDragHandle(cart) {
    return cart ? cart.querySelector('[data-cart-drag-handle]') : null;
  }

  function getAnchorHeading() {
    return document.querySelector('.collection__title-inner-stack .collection__title-heading');
  }

  function hasCollectionCart() {
    return !!document.querySelector('.milk-cart-global--collection');
  }

  function isCollectionLandingCart() {
    return !!document.querySelector('.collection-with-filter--no-title');
  }

  function getLandingCartLeft() {
    return window.matchMedia('(min-width: 750px)').matches ? 38 : 24;
  }

  function bindCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.setHeaderCartIconAccessibility === 'function') {
      drawer.setHeaderCartIconAccessibility();
    }
  }

  function loadSavedPosition() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var pos = JSON.parse(raw);
      if (typeof pos.left === 'number' && typeof pos.top === 'number') return pos;
    } catch (e) {}
    return null;
  }

  function savePosition(left, top) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ left: left, top: top }));
    } catch (e) {}
  }

  function clearSavedPosition() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function clampPosition(cart, left, top) {
    var width = cart.offsetWidth || 60;
    var height = cart.offsetHeight || 24;
    return {
      left: Math.max(8, Math.min(left, window.innerWidth - width - 8)),
      top: Math.max(8, Math.min(top, window.innerHeight - height - 8)),
    };
  }

  function setCartPosition(cart, left, top, mode) {
    var clamped = clampPosition(cart, left, top);
    cart.style.left = Math.round(clamped.left) + 'px';
    cart.style.top = Math.round(clamped.top) + 'px';
    cart.classList.add('milk-cart-global--locked');
    cart.classList.remove('milk-cart-global--anchored', 'milk-cart-global--custom');
    if (mode) cart.classList.add('milk-cart-global--' + mode);
  }

  function revealCart(cart) {
    if (!cart || cartReady) return;
    cart.classList.add('milk-cart-global--ready');
    cartReady = true;

    var layout = document.querySelector('.collection-with-filter--has-sidebar');
    if (layout) layout.classList.add('collection-with-filter--ready');

    var listLayout = document.querySelector('.list-collections-milk');
    if (listLayout) listLayout.classList.add('list-collections-milk--ready');
  }

  function markCollectionLayoutReady() {
    var layout = document.querySelector('.collection-with-filter--has-sidebar');
    if (layout) layout.classList.add('collection-with-filter--ready');

    var listLayout = document.querySelector('.list-collections-milk');
    if (listLayout) listLayout.classList.add('list-collections-milk--ready');
  }

  function positionCartAboveHeading() {
    var cart = getCart();
    if (!cart) return false;

    var saved = loadSavedPosition();
    if (saved) {
      setCartPosition(cart, saved.left, saved.top, 'custom');
      return true;
    }

    if (isCollectionLandingCart()) {
      setCartPosition(cart, getLandingCartLeft(), getTopBarOffset(), 'anchored');
      return true;
    }

    var heading = getAnchorHeading();
    var left = heading ? heading.getBoundingClientRect().left : getLandingCartLeft();

    setCartPosition(cart, left, getTopBarOffset(), 'anchored');
    return true;
  }

  function positionFallbackCart() {
    var cart = getCart();
    if (!cart || hasCollectionCart()) return;

    var saved = loadSavedPosition();
    if (saved) {
      setCartPosition(cart, saved.left, saved.top, 'custom');
      return;
    }

    cart.classList.add('milk-cart-global--locked');
    cart.classList.add('milk-cart-global--anchored');
  }

  function lockCartPosition() {
    if (hasCollectionCart()) {
      return positionCartAboveHeading();
    }

    positionFallbackCart();
    return true;
  }

  function syncCartPosition(reveal) {
    var cart = getCart();
    if (!cart) return;

    var positioned = lockCartPosition();
    bindCartDrawer();

    if (reveal && positioned) {
      revealCart(cart);
    }
  }

  function initCartPosition() {
    var finishInit = function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          syncCartPosition(true);
        });
      });
    };

    if (document.querySelector('[data-announcement-banner]')) {
      if (getAnnouncementHeight() > 0) {
        finishInit();
        return;
      }

      window.addEventListener('milk:announcement-resize', finishInit, { once: true });
      return;
    }

    finishInit();
  }

  function initDrag(cart) {
    var handle = getDragHandle(cart);
    if (!handle) return;

    var dragging = false;
    var didDrag = false;
    var startX = 0;
    var startY = 0;
    var startLeft = 0;
    var startTop = 0;

    handle.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;

      dragging = true;
      didDrag = false;
      startX = e.clientX;
      startY = e.clientY;

      var rect = cart.getBoundingClientRect();
      startLeft = rect.left;
      startTop = rect.top;

      cart.classList.add('milk-cart-global--dragging');
      if (handle.setPointerCapture) handle.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!didDrag && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
        didDrag = true;
      }

      if (!didDrag) return;

      var next = clampPosition(cart, startLeft + dx, startTop + dy);
      setCartPosition(cart, next.left, next.top, 'custom');
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      cart.classList.remove('milk-cart-global--dragging');
      if (handle.releasePointerCapture && e.pointerId !== undefined) {
        try {
          handle.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }
    }

    handle.addEventListener('pointerup', endDrag);
    handle.addEventListener('pointercancel', endDrag);

    handle.addEventListener('dblclick', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearSavedPosition();
      syncCartPosition(false);
    });
  }

  function onResize() {
    if (loadSavedPosition()) {
      syncCartPosition(false);
      return;
    }

    if (hasCollectionCart()) {
      syncCartPosition(false);
    }
  }

  function onAnnouncementResize() {
    var height = getAnnouncementHeight();
    if (Math.abs(height - lastBannerHeight) < 1) return;
    lastBannerHeight = height;

    if (loadSavedPosition()) return;
    syncCartPosition(!cartReady);
  }

  function init() {
    var cart = getCart();
    if (!cart) {
      markCollectionLayoutReady();
      return;
    }

    lastBannerHeight = getAnnouncementHeight();
    initDrag(cart);
    initCartPosition();

    window.addEventListener('resize', onResize);
    window.addEventListener('milk:announcement-resize', onAnnouncementResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
